<script>
/**
 * Simple mixin to access HelpOverlay component
 */
export default {
  computed: {
    isOnDemoMode() {
      return this.App.isOnDemoMode;
    },
    neoHelp() {
      return this.App.$refs.iaHelp;
    },
    neoOverlay() {
      return this.App.$refs.iaOverlay;
    },
  },
};
</script>
